import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { RiFileList2Fill } from "react-icons/ri";
import { TiTick } from "react-icons/ti";
import { ImCross } from "react-icons/im";
import Service from '../Service/http';

 function List() {
  const service = new Service();
  const [data,SetData] = useState({});
  useEffect(()=>{
    service.get("api/all/problems").then((res)=>{
      SetData(res);
    })
  },[]);

  return (
    <Container className=" row justify-content-md-center">
      <div className="col-sm-8 ">

        <div className="mt-4">
          <h1 className="text-start "> Problem Set </h1>
        </div>

        <br />

        {data.sections?data.sections.map((ele) => {
          return (
            <div className="row justify-content-md-center" key={ele.title}>
              <h3 className="text-start text-primary col-sm-12">
                {" "}
                {ele.title}{" "}
              </h3>
              {ele.problems.map((e) => {
                return (
                  <div className="row " key={e}>
                    <div className="col-sm-5 text-secondary">
                      {" "}
                      <RiFileList2Fill />{" "}
                      <a href={"/code/" + e.id}>
                        {" "}
                        {e.title}{" "}
                      </a>{" "}
                    </div>
                    <div className="col-sm-5 text-muted">
                      {" "}
                      {e.accepted_count} / {e.submissions_count}{" "}
                    </div>
                    <div className="col-sm-2 text-muted">
                      {" "}
                      {e.solved === "solved" ? (
                        <TiTick color="green" size={25} />
                      ) : (
                        <>
                          {" "}
                          {e.solved === "attempted" ? (
                            <ImCross color="red" size={15} />
                          ) : (
                            "--"
                          )}{" "}
                        </>
                      )}{" "}
                    </div>
                    <hr />
                  </div>
                );
              })}
            </div>
          );
        }):null}
      </div>
    </Container>
  );
}


export default List;
